/* eslint-disable */

'use strict';

window.Backbone = require('backbone');

window.Backbone.$ = require('jquery'); // eslint-disable-line
